<template>
    <div>
        <my-header :title="resource.title" :is-back="true"/>

        <!-- wrap -->
        <div class="img-swipe-wrap">
            <!-- 使用轮播组件展示图片专辑 -->
            <van-swipe class="img-swipe" @change="onChange">
                <van-swipe-item v-for="(item,index) in list" :key="index">
                    <van-image :src="item.cover" fit="contain"
                               width="100%" height="calc(70vh - 25px)"
                               @click="showBigImg(item.cover)"
                    />
                </van-swipe-item>

                <!-- 自定义指示器 -->
                <template #indicator>
                    <div class="custom-indicator">{{ current + 1 }}/{{list.length}}</div>
                </template>
            </van-swipe>

            <!-- 简介区 -->
            <div class="info-wrap">
                <div class="title">{{list[current].title}}</div>
                <p class="description">{{list[current].description}}</p>
            </div>
        </div>

        <!-- 大图模式 -->
        <van-popup v-model:show="bigImgPopup"
                   position="bottom"
                   round
                   :style="{ height: 'calc(90% - 50px)' }"
        >
            <div class="popup-content">
                <div class="option-list">
                    &nbsp;
                    <!-- 功能直接砍掉 -->
<!--                    <div>-->
<!--                        <span>-->
<!--                            <font-awesome-icon icon="reply" class="icon"/>向左转-->
<!--                        </span>-->
<!--                        &nbsp;|&nbsp;-->
<!--                        <span>-->
<!--                            <font-awesome-icon icon="share" class="icon"/>向右转-->
<!--                        </span>-->
<!--                    </div>-->
                    <!-- 关闭按钮 -->
                    <van-icon name="cross" @click="bigImgPopup = false"/>
                </div>
                <div class="big-img">
                    <img :src="bigImgUrl"/>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import {ref} from 'vue';
import MyHeader from "@/components/myHeader";
import LoadResource from "@/views/resource/LoadResource";
import AddPointMixin from "@/views/resource/AddPointMixin";

export default {
    name: "ResourceImg",
    components:{MyHeader},
    mixins:[AddPointMixin],
    props:{
        id:{
            type:String,
            required:true,
        }
    },
    watch:{
        id(val){
            this.initLoadResource(val,true)
        }
    },
    setup(props){
        const obj = new LoadResource(props.id,true)
        const initLoadResource = (id,fetchContent) => obj.init(id,fetchContent);
        const loadResource = () => obj.loadResource();

        return{
            // 服务端响应数据
            resource:obj.resource,
            // 加载数据中
            loading:obj.loading,
            // 初始化，重新加载数据
            initLoadResource,
            // 加载数据
            loadResource,
            current:ref(0),
            bigImgPopup:ref(false),
            bigImgUrl:ref(null),

        }
    },
    computed:{
        // 计算图片列表
        list(){
            const r = this.resource
            if(!r) return []
            const item = r.item
            const rItem = {
                cover:r.cover,
                description:r.description,
                title:r.title,
            }
            if(!item || !item.length){
                return [rItem]
            }
            return item
        }
    },
    methods:{
        onChange(i){
            this.current = i;
        },
        /** 进入大图模式 */
        showBigImg(cover){
            this.bigImgUrl = cover
            this.bigImgPopup = true
        }
    }
}
</script>

<style scoped>
.custom-indicator {
    position: absolute;
    right: 5px;
    bottom: 5px;
    padding: 2px 5px;
    font-size: 16px;
    background: rgba(0, 0, 0, 0.1);
    color: #eee;
}

.img-swipe-wrap{
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000;
}
.img-swipe{
    width: 100%;
    height: calc(70vh - 25px);
}
.info-wrap{
    height: calc(30vh - 25px - 10px * 2);
    background-color: #FFF;
    padding: 10px 15px;
    overflow: hidden;
    color: #3E3E3E;
}
.info-wrap > .title{
    font-weight: bold;
    height: 24px;
    font-size: 16px;
}
.info-wrap > .description{
    font-size: 13px;
    color: #4e4e4e;
    overflow-y: auto;
    white-space: break-spaces;
    word-wrap: break-word;
    word-break: break-all;
    height: calc(30vh - 25px - 10px * 2 - 24px);
    width: 100%;
}

.popup-content{
    padding: 10px 15px;
}
.popup-content > .option-list{
    height: 40px;
    /*width: calc(100% - 15px * 2);*/
    /*position: fixed;*/
    z-index: 2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #FFF;
}
.popup-content > .big-img{

}
.popup-content > .big-img > img{
    object-fit: cover;
    width: 100%;
    height: auto;
}
</style>
